import { useAuth } from '../context/AuthContext';
import AdminCodesPage from './codes/AdminCodesPage';
import SalesCodesPage from './codes/SalesCodesPage';
import TeacherCodesPage from './codes/TeacherCodesPage';

/**
 * Module 7 shows three different things under one route, because the design gives
 * each role its own entry to it: the admin mints and audits, the rep allocates, the
 * teacher distributes.
 */
export default function ActivationCodesPage() {
  const { user } = useAuth();

  if (user?.role === 'TEACHER') return <TeacherCodesPage />;
  if (user?.role === 'SALES_REP') return <SalesCodesPage />;
  return <AdminCodesPage />;
}
